import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGitlab, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faLocationPin } from '@fortawesome/free-solid-svg-icons';
import './Contact.css';

const Contact = () => {
  const [state, handleSubmit] = useForm("mqebjvyq");

  return (
    <div className="contact-container" id="contact">
      <div className="contact-content">
        <div className="contact-info">
          <h2>Let's Work Together</h2>
          <p className="contact-subtitle">
            I'm always interested in hearing about new projects and opportunities.
            Whether you have a question or just want to say hi, feel free to reach out!
          </p>

          <div className="contact-details">
            <div className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
              <div>
                <h4>Email</h4>
                <a href="mailto:john016dionisio@gmail.com">john016dionisio@gmail.com</a>
              </div>
            </div>

            <div className="contact-item">
              <FontAwesomeIcon icon={faLocationPin} className="contact-icon" />
              <div>
                <h4>Location</h4>
                <p>Guiguinto, Bulacan, Philippines</p>
              </div>
            </div>
          </div>

          <div className="contact-social">
            <h4>Connect with me</h4>
            <div className="social-links">
              <a href="https://gitlab.com/users/samaniego.johnjordan/groups" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faGitlab} />
              </a>
              <a href="https://github.com/jordge06" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a href="https://www.linkedin.com/in/john-jordan-samaniego-1712821b7/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>
        </div>

        <div className="contact-form-wrapper">
          {state.succeeded ? (
            <div className="success-message">
              <h3>Thank you!</h3>
              <p>Your message has been sent successfully. I'll get back to you soon!</p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <h3>Send me a message</h3>
              
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  placeholder="Your name"
                />
                <ValidationError 
                  prefix="Name" 
                  field="name"
                  errors={state.errors}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  placeholder="your.email@example.com"
                />
                <ValidationError 
                  prefix="Email" 
                  field="email"
                  errors={state.errors}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows="5"
                  placeholder="Tell me about your project or inquiry..."
                />
                <ValidationError 
                  prefix="Message" 
                  field="message"
                  errors={state.errors}
                />
              </div>

              <button type="submit" className="submit-btn" disabled={state.submitting}>
                {state.submitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;